/**
 * The description and link-preview tags in the language on screen (DECIDED
 * 20261020, system specification §3.8). `index.html` ships them in
 * Hungarian, written in by `brandMetaPlugin` (`apps/web/siteMeta.ts`); this
 * turns them with the language switch, as the tab title turns.
 */

import { useEffect } from 'react'

import { brandDescription, brandTitle } from '@plt/emails'

import type { Lang } from './lang.ts'

function setMeta(document: Document, key: 'name' | 'property', value: string, content: string): void {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${key}="${value}"]`)
  if (tag === null) {
    tag = document.createElement('meta')
    tag.setAttribute(key, value)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

export function applyBrandMeta(document: Document, lang: Lang): void {
  const title = brandTitle(lang)
  const description = brandDescription(lang)
  setMeta(document, 'name', 'description', description)
  setMeta(document, 'property', 'og:title', title)
  setMeta(document, 'property', 'og:site_name', title)
  setMeta(document, 'property', 'og:description', description)
  setMeta(document, 'property', 'og:locale', lang === 'en' ? 'en_GB' : 'hu_HU')
}

export function useBrandMeta(lang: Lang): void {
  useEffect(() => {
    applyBrandMeta(document, lang)
  }, [lang])
}
